module.exports = __webpack_public_path__ + "assets/b6a16d7a5bba911aa85df282dc00ae6c.png";